export function getFileBase64(file: File): Promise<string> {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
        reader.onerror = () => {
            reader.abort();
            reject(new Error("Error parsing file"));
        }
        reader.onload = function () {
            // @ts-ignore
            let bytes = Array.from(new Uint8Array(this.result));
            let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(""));
            resolve(base64StringFile);
        }
        reader.readAsArrayBuffer(file);
    });
}

export const decodeBase64 = (base64Str: string) => {
    return fetch(`data:image/jpeg;base64,${base64Str}`).then(it => it.blob());
}